import getReportAnalytics from "@custom/rtk-apis/analytics/getReportAnalytics";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getReportAnalyticsSlice = createSlice({
  name: "getReportAnalyticsSlice",
  initialState,
  reducers: {
    clearReportAnalyticsStatus: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReportAnalytics.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getReportAnalytics.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getReportAnalytics.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getReportAnalyticsSlice.reducer;
export const { clearReportAnalyticsStatus } = getReportAnalyticsSlice.actions;
